import { forwardRef } from "react";
import { QRCode } from "antd";
import { getRetouchReviewCopy } from "../../utils/retouchReviewCopy";
import { formatRetouchPosterExpiry } from "../../utils/retouchReviewPoster";
import { useTranslation } from "../../i18n";
import "./RetouchReviewPoster.css";

const RetouchReviewPoster = forwardRef(function RetouchReviewPoster({ albumName, expiry, url }, ref) {
    const { locale } = useTranslation();
    const copy = getRetouchReviewCopy(locale);
    return (
        <div ref={ref} className="retouch-review-poster">
            <div className="retouch-review-poster__inner">
                <header className="retouch-review-poster__header">
                    <div className="retouch-review-poster__brand">HEI CREATIVE</div>
                    <h1 className="retouch-review-poster__title">{albumName}</h1>
                    <div className="retouch-review-poster__subtitle">{copy.posterSubtitle}</div>
                </header>
                <section className="retouch-review-poster__qr-section">
                    <div className="retouch-review-poster__qr-wrapper">
                        <div className="retouch-review-poster__qr-inner">
                            {url && <QRCode value={url} size={190} color="#1d1d1f" bgColor="#ffffff" bordered={false} errorLevel="M" />}
                        </div>
                    </div>
                    <div className="retouch-review-poster__qr-text">{copy.posterScan}</div>
                </section>
                <footer className="retouch-review-poster__footer">
                    <div className="retouch-review-poster__divider" />
                    <div className="retouch-review-poster__expiry">{copy.posterExpiry} · {formatRetouchPosterExpiry(expiry)}</div>
                    <div className="retouch-review-poster__social">HEI CREATIVE · RETOUCH REVIEW</div>
                    <div className="retouch-review-poster__website">HEICREATIVE.CO.UK</div>
                </footer>
            </div>
        </div>
    );
});

export default RetouchReviewPoster;
